export const Assessments = {
  row: {
    "&.Assessments-ItemRow": {
      
      "&.Assessments-SectionTitle": {
        " .Cirrus-mainColumn": {
          fontSize: "17px",
        }
      },
      
      "&.Assessments-SectionItem": {
        backgroundColor: "#f6f6f6",
        "&:hover": {
          opacity: .8
        },
  
        "&.NonDraggable": {
        },
        
        "&.NonSelectable": {
          ".MuiDataGrid-cellCheckbox > span": {
            display: "none",
          }
        }
      },
    },
  },
}
